{
  "version": 1,
  "asset_id": "2fdb3f55-72a6-45f7-99f9-bf2c2f0d7fa7",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/2fdb3f55-72a6-45f7-99f9-bf2c2f0d7fa7/agent-tour-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/2fdb3f55-72a6-45f7-99f9-bf2c2f0d7fa7/agent-tour-placeholder.jpg",
  "original_filename": "agent-tour-placeholder.jpg",
  "size": 141329,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T14:49:42Z"
}
